module.exports = __webpack_public_path__ + "static/img/tick.b60c83ba.svg";